import { Stack, Typography } from '@mui/material';
import Icon from 'components/Icon';
import React from 'react';

function RequiredBadge({ isSatisfied = false, needSelection  }) {
  const backgroundColor = isSatisfied ? 'background.success' : needSelection ? 'background.error' : 'background.elevation2';
  const textColor = isSatisfied ? 'success.main' : needSelection ? 'error.main' : 'text.secondary';
  return (
    <Stack
      direction="row"
      alignItems="center"
      gap={0.5}
      sx={{
        borderRadius: '12px',
        backgroundColor: backgroundColor,
        py: 0.5,
        px: 1,
      }}
    >
      {isSatisfied && <Icon name="checkmark" sx={{ color: 'success.main' }} />}
      <Typography variant="body-overline" fontWeight="bold" color={textColor}>
        Required
      </Typography>
    </Stack>
  );
}
export default RequiredBadge;
